class LocalStorageService {
    static validateKey(key: string): void {
        if (!key || typeof key !== 'string') {
            throw new Error('Invalid key provided to LocalStorageService');
        }
    }

    // Generic method for type-safe retrieval
    static get<T>(key: string): T | undefined {
        this.validateKey(key);
        try {
            const value = localStorage.getItem(key);
            return value ? (JSON.parse(value) as T) : undefined;
        } catch (e) {
            console.error(`Error parsing localStorage key "${key}":`, e);
            return undefined;
        }
    }

    static set<T>(key: string, value: T): void {
        this.validateKey(key);
        localStorage.setItem(key, JSON.stringify(value));
    }

    static append<T>(key: string, value: T): void {
        this.validateKey(key);
        const list = this.get<T[]>(key) || [];
        if (!Array.isArray(list)) {
            throw new Error(`Unable to append value in local storage: "${key}" is not an array`);
        }
        list.push(value);
        this.set(key, list);
    }

    static remove(key: string): void {
        this.validateKey(key);
        localStorage.removeItem(key);
    }

    static clear(): void {
        localStorage.clear();
    }

    static exists(key: string): boolean {
        this.validateKey(key);
        return localStorage.getItem(key) !== null;
    }
}

export default LocalStorageService;
